
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {
  CodeBlock,
  ComponentDocs,
  DocsTable,
  Preview,
  md,
} from "@lighting-beetle/lighter-styleguide";
import Select from "./index";
import Grid, { GridCol } from "../../Grid/index";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Select`}</h1>
    <h2>{`Example`}</h2>
    <Select id="select-example" mdxType="Select">
  <option>Item 1</option>
  <option>Item 2</option>
    </Select>
    <h2>{`Variants`}</h2>
    <h3>{`Basic`}</h3>
    <Preview mdxType="Preview">
  <Select id="select-basic" mdxType="Select">
    <option>Item 1</option>
    <option>Item 2</option>
  </Select>
    </Preview>
    <h3>{`With label`}</h3>
    <Preview mdxType="Preview">
  <Select id="select-with-label" label="Label" mdxType="Select">
    <option>Item 1</option>
    <option>Item 2</option>
  </Select>
    </Preview>
    <h3>{`States`}</h3>
    <Preview code={[<Select key="select-disabled" id="select-disabled" isDisabled mdxType="Select">
      <option>Item 1</option>
      <option>Item 2</option>
    </Select>, <Select key="select-error" id="select-error" error mdxType="Select">
      <option>Item 1</option>
      <option>Item 2</option>
    </Select>]} mdxType="Preview">
  <Grid mdxType="Grid">
    <GridCol size={{
          s: 6,
          l: 3
        }} mdxType="GridCol">
      <Select id="select-disabled" isDisabled mdxType="Select">
        <option>Item 1</option>
        <option>Item 2</option>
      </Select>
    </GridCol>
    <GridCol size={{
          s: 6,
          l: 3
        }} mdxType="GridCol">
      <Select id="select-error" error mdxType="Select">
        <option>Item 1</option>
        <option>Item 2</option>
      </Select>
    </GridCol>
  </Grid>
    </Preview>
    <h3>{`Sizes`}</h3>
    <Preview mdxType="Preview">
  <Select id="select-large" size="large" mdxType="Select">
    <option>Large select</option>
    <option>Item 2</option>
  </Select>
  <Select id="select-medium" mdxType="Select">
    <option>Medium select</option>
    <option>Item 2</option>
  </Select>
  <Select id="select-small" size="small" mdxType="Select">
    <option>Small select</option>
    <option>Item 2</option>
  </Select>
    </Preview>
    <h3>{`With placeholder`}</h3>
    <Preview mdxType="Preview">
  <Select id="select-with-placeholder" placeholder="Placeholder" mdxType="Select">
    <option>Item 1</option>
    <option>Item 2</option>
  </Select>
    </Preview>
    <h3>{`Clearable`}</h3>
    <Preview mdxType="Preview">
  <Select value="item 2" isClearable id="select-clearable" placeholder="Placeholder" mdxType="Select">
    <option value="item 1">Item 1</option>
    <option value="item 2">Item 2</option>
  </Select>
    </Preview>
    <h2>{`Props`}</h2>
    <ComponentDocs title="<Select />" component={Select} mdxType="ComponentDocs" />
    <h2>{`JS module reference`}</h2>
    <p>{`Select is backed with `}<a parentName="p" {...{
        "href": "https://github.com/jshjohnson/Choices"
      }}>{`Choices.js | see docs`}</a></p>
    <p>{`If you omit `}<inlineCode parentName="p">{`data-select`}</inlineCode>{` attribute on `}<inlineCode parentName="p">{`<select />`}</inlineCode>{` element, select won't be initialized and you need to initialize it manually.`}</p>
    <CodeBlock language="jsx" mdxType="CodeBlock">
  {`
const mySelect = new window.myApp.Select( document.getElementById('my-select'), config );
// call Choices.js function on instance (see Choices.js docs)
mySelect.instance.setChoices(
[
{ value: 'One', label: 'Label One', disabled: true },
{ value: 'Two', label: 'Label Two', selected: true },
{ value: 'Three', label: 'Label Three' },
],
'value',
'label',
false
);
`}
    </CodeBlock>
    <p>{`You can also set choices as element `}<inlineCode parentName="p">{`<option />`}</inlineCode>{`.`}</p>
    <CodeBlock language="html" mdxType="CodeBlock">
  {`
<select id="my-select">
<option>Default<option>
</select>
`}
    </CodeBlock>
    <h3>{`Config`}</h3>
    <DocsTable data={[{
      prop: "",
      type: "object",
      default: `
{
search: false,
searchEnabled: false,
searchChoices: false,
shouldSort: false,
}`,
      description: "Default config for Choices.js module, for more see docs (https://github.com/jshjohnson/Choices)."
    }]} mdxType="DocsTable" />
    <h3>{`Methods`}</h3>
    <CodeBlock language="jsx" mdxType="CodeBlock">
  {`
const instance = window.myApp.Select.getInstance(el);
/*
instance.method();
*/
`}
    </CodeBlock>
    <DocsTable data={[{
      prop: "init",
      type: "func",
      default: "() => {}",
      description: "Initialize instance. This is called automatically on `new Plugin(el, config)`"
    }, {
      prop: "destroy",
      type: "func",
      default: "() => {}",
      description: "Destroy the instance."
    }, {
      prop: "update",
      type: "func",
      default: "() => {}",
      description: "Updates the instance (reinitalize)."
    }, {
      prop: "static getInstance",
      type: "func",
      default: "element => {}",
      description: "Get instance of `Select` attached to specific DOM element (usually `[data-select]`)."
    }]} mdxType="DocsTable" />
    <h2>{`Accessibility`}</h2>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;